import React from 'react';
function Hire({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 19.5c0-2.778 2.5-4.5 6-5-2.5-.5-4-2.5-4-5 0-3 2.221-5 4.72-5C13.219 4.5 16 5.656 16 9v1"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.5 19a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
        clipRule="evenodd"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 20l-2-2" />
    </svg>
  );
}

export default Hire;
